// extracted by mini-css-extract-plugin
export default {"container":"SeriesNftRow_container__avcgT","nftPhoto":"SeriesNftRow_nftPhoto__5gTYO"};